// extracted by css-extract-rspack-plugin
export default {"admonition":"admonition_IZjC","admonitionHeading":"admonitionHeading_uVvU","admonitionIcon":"admonitionIcon_HiR3","admonitionContent":"admonitionContent_bl22"};